module.exports = __webpack_public_path__ + "static/img/2017122713492412.84cc658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2017122713492412.jpg
// module id = rgQk
// module chunks = 0